import { Component } from '@angular/core';

@Component({
  selector: 'scv-footer',
  templateUrl: 'footer.html'
})
export class FooterComponent {}